module.exports = __webpack_public_path__ + "static/img/MIKOSA_LOGO_BLACK.b0add4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/MIKOSA_LOGO_BLACK.png
// module id = SQlR
// module chunks = 0